import React, { Fragment } from 'react';
import { BulkDeleteButton } from 'react-admin';

const PostBulkActionButtons = props => (
  <Fragment>
    <BulkDeleteButton {...props} />
  </Fragment>
);

export default PostBulkActionButtons;



// WEBPACK FOOTER //
// ./src/views/Common/Partials/Helpers/PostBulkActionButtons.tsx